/**
 * @format
 * @module ui/templates/notifications
 */

/**
 * Generate a website alert
 * @param {Object} c - collection of properties
 * @param {String} [c.id=""] - unique JS identifier
 * @param {String} [c.alertId=""] - data-attribute unique alert name
 * @param {String} [c.type="system"] - variant type of alert
 * @param {String} [c.classes=[]] - additional classes to apply
 * @param {String} [c.title=""] - primary title/heading
 * @param {String} [c.content=""] - main body content
 * @param {String} [c.foot=""] - secondary foot content
 * @param {String} [c.wrap] - wrap entire alert in div with supplied class
 * @returns {String}
 */
export function websiteAlert({
  id = "",
  alertId = "",
  type = "system",
  classes = [],
  title = "",
  content = "",
  foot = "",
  wrap
}) {
  const divID = id && id !== "" ? ` id="${id}"` : "";
  const dataID = alertId && alertId !== "" ? ` data-alertid="${alertId}"` : "";
  const klasses = classes && Array.isArray(classes) ? " " + classes.join(" ") : "";

  const head = title ? `<h3 class="c-website-alert__title">${title}</h3>` : "";
  const body = content ? `<div class="c-website-alert__content">${content}</div>` : "";

  const alert = /* HTML */ `
    <div${divID}${dataID} class="c-website-alert c-website-alert--${type}${klasses}" aria-live="polite">
      ${head}${body}${foot}
    </div>
  `;

  return wrap ? `<div class="${wrap}">${alert}</div>` : alert;
}

/**
 * Sets up event handler for use notification dismiss button.
 * @param {HTMLElement} container - delegated as click event listener
 * @param {String} buttonSelector - for the dismiss button
 * @param {Function<String>} [onClick] - callback with alert id
 */
export function websiteAlertDismissListener(container, buttonSelector, onClick) {
  if (!container) {
    return;
  }
  container.addEventListener("click", e => {
    const dismissEl = e.target.closest(buttonSelector);
    if (!dismissEl) {
      return;
    }
    const id = dismissEl.parentElement.dataset.alertid;

    // Remove entire feature, including the margins.
    const feature = dismissEl.closest(".u-wrapper");
    feature && feature.parentNode.removeChild(feature);

    if (onClick) {
      onClick(id);
    }
  });
}

/**
 * Let's use this global alert placement, and insert various site notification types there.
 * @type {String}
 */
export const websiteAlertNodeSelector = ".js-c-website-alert-node";
